import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Compass, Ruler, Box, Check } from 'lucide-react';
import { expertiseServices } from '../data/mock';

const iconMap = {
  Compass: Compass,
  Ruler: Ruler,
  Box: Box
};

export const Expertise = () => {
  return (
    <section id="expertise" className="py-24 bg-dark">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="h-[1px] w-12 bg-gold mx-auto"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-white mb-6">
            Notre Expertise
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Un savoir-faire technique au service de vos ambitions esthétiques
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {expertiseServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="bg-light/5 backdrop-blur-sm border-gold/20 hover:border-gold/50 transition-all duration-500 hover:-translate-y-2 group shadow-luxury"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-gold/10 rounded-sm flex items-center justify-center mb-4 group-hover:bg-gold/20 transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-gold" />
                  </div>
                  <CardTitle className="text-2xl font-playfair text-white mb-3">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-400 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-gray-300">
                        <Check className="w-4 h-4 text-neon mr-2 flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
